import { useEffect } from 'react';
import { useRouter } from 'next/router';
import bookingStep from '../enum/bookingStep';

const useAssignmentRedirect = (shouldRedirect) => {
  const router = useRouter();

  useEffect(() => {
    if (!shouldRedirect) return;

    const assignmentRoute = bookingStep.route.assignment;
    const currentPath = (router.asPath || router.pathname || '').split('?')[0];
    if (currentPath === assignmentRoute || router.pathname === assignmentRoute) {
      router.reload();
    } else {
      router.push(assignmentRoute);
    }
  }, [shouldRedirect, router]);
};

export default useAssignmentRedirect;
